module.exports = __webpack_public_path__ + "img/recover.52acae5d.svg";